import { useEffect, useState } from "react";

// Cookie consent (Garante Privacy): nothing optional runs until the visitor chooses.
// stats = PostHog statistics, maps = Google Maps embeds. Technical storage (language, form data) is always allowed.
const KEY = "cookie-consent";
const VERSION = 1;
const EVENT = "consent-change";

export const readConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c?.v === VERSION ? c : null;
  } catch {
    return null;
  }
};

const applyStats = (on) => {
  const ph = window.posthog;
  if (!ph?.opt_in_capturing) return;
  if (on) ph.opt_in_capturing();
  else ph.opt_out_capturing();
};

export const saveConsent = ({ stats, maps }) => {
  const c = { v: VERSION, stats: !!stats, maps: !!maps, date: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(c));
  applyStats(c.stats);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: c }));
  return c;
};

export const openCookieSettings = () => window.dispatchEvent(new Event("open-cookie-settings"));

// Re-apply a stored choice on load (e.g. analytics storage was cleared but consent remains).
export const restoreConsent = () => { const c = readConsent(); if (c) applyStats(c.stats); };

export const useConsent = () => {
  const [consent, setConsent] = useState(readConsent);
  useEffect(() => {
    const on = (e) => setConsent(e.detail);
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return consent;
};
